import { useEffect } from 'react';
import { useIsInExternalPlatform } from '@/shared/externalPlatform';
import { useTrialEndDiscount } from '@/shared/plan/useTrialEndDiscount';
import { trialEndDiscountStorage } from '../storage';
import { openTrialEndDiscountModal } from './openTrialEndDiscountModal';
import { useIsTrialEndDiscountSuppressed } from './useIsTrialEndDiscountSuppressed';
const MODAL_DELAY_MS = 300;

/**
 * 체험 종료 할인 모달 자동 노출 (PRD 솔루션 6, S6-01/02).
 * windowEnd 당 1회만 뜬다. `_app` 에서 `TrialVoucherRewardModalGate` 옆에 마운트한다.
 */
export const TrialEndDiscountGate = () => {
  const discount = useTrialEndDiscount();
  const windowEndIso = discount.windowEnd?.toISOString() ?? null;
  const isVisible = discount.status === 'active' || discount.status === 'urgent';
  const isSuppressedPath = useIsTrialEndDiscountSuppressed();
  const isInExternalPlatform = useIsInExternalPlatform();
  useEffect(() => {
    if (!isVisible || !windowEndIso || isSuppressedPath || isInExternalPlatform) return;
    if (!trialEndDiscountStorage.shouldShowModal(windowEndIso)) return;
    const timer = setTimeout(() => {
      trialEndDiscountStorage.markModalShown(windowEndIso);
      openTrialEndDiscountModal(discount, 'auto');
    }, MODAL_DELAY_MS);
    return () => clearTimeout(timer);
    // discount 는 1분마다 새 객체라 의존성에서 제외한다(모달을 다시 열 이유가 없다).
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isVisible, windowEndIso, isSuppressedPath, isInExternalPlatform]);
  return null;
};